import { useRef } from 'react';
import InfoCardItem from './StatisticCardItem';
import './styles.scss'
import { useAnimation } from 'hooks/useAnimation';


const StatisticCards = ({ data, isLoading }) => {
    const container = useRef();

    useAnimation({
        items: ['.statistic-cards-item'],
        container,
        dependencies: [isLoading],
    })
    return (
        <section ref={container} className="inner-container statistic-cards">
            {
                data.card?.map((item, index) => (
                    <InfoCardItem key={index} data={item} />
                ))
            }
        </section>
    );
}

export default StatisticCards; 